import { derived } from 'svelte/store';
import { isActiveSlugRoute } from '../navigation';

export const isPracticeOrPlay = () =>
    derived([isActiveSlugRoute('PLAY'), isActiveSlugRoute('PRACTICE')], (stores) =>
        stores.some(Boolean)
    );
